import { jaroWinklerDistance } from '../../utils/jaroWinklerDistance.js';
import { max } from '../../utils/maxBy.js';
import { sum } from '../../utils/sum.js';
import { tokenize } from './tokenize.js';
export const textRank = (queryTokens) => (text) => {
    const textTokens = tokenize(text || '');
    return textTokens.length
        ? sum(queryTokens.map((qToken) => max(textTokens.map(jaroWinklerDistance(qToken)))))
        : 0;
};
//# sourceMappingURL=textRank.js.map